import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { Subject } from "rxjs";
import { TranslateService } from "@ngx-translate/core";
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ErrorMessageKeyService } from "../Services/error-message-key.service";
import { DectorService } from './../Services/dector.service';
import { AuthService } from '../Services/auth.service';
import { CommonService } from '../Services/common.service';
import { CookieService } from '../Services/cookie';
import { browserRefresh } from '../app.component';
import { PinService } from '../Services/pin.service';
import { SettingService } from "../Services/setting.service";

@Component({
  selector: "app-create-password",
  templateUrl: "./create-password.component.html",
  standalone:false,
  styleUrls: ["./create-password.component.scss"],
})
export class CreatePasswordComponent implements OnInit {
  modalObservable: Subject<void> = new Subject<void>();
createpassForm: FormGroup;
  idnumber: string;
  mobileminlength: any;
  mobilemaxlength: any;
  confirmPass
  createpass1

    constructor( private router: Router, private location: Location,private auth: AuthService,private setting: SettingService, private commonService: CommonService,private pinservice:PinService, public errorKey: ErrorMessageKeyService,private translate: TranslateService, private dectorService: DectorService,private fb: FormBuilder, private _router: Router, private cookieService: CookieService
  ) { 

//  this.createpassForm = this.fb.group({
//       passwordCreateform: [
//         '',
//         [
//           Validators.required,
//           Validators.minLength(8), // kam az kam 8 characters
//           Validators.maxLength(20),
//           Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).+$/) 
//           // 1 uppercase, 1 lowercase, 1 number, 1 special char
//         ],
//       ],
//     });
this.createpassForm = this.fb.group({
  passwordCreateform: [
    '',
    [
      Validators.required,
      Validators.minLength(8),
      Validators.maxLength(20),
      Validators.pattern(/^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[\W_]).+$/)
    ],
  ],
  confirmPassword: [
    '',
    [Validators.required]
  ]
}, {
  validators: this.passwordMatchValidator
});


   }
   async ngOnInit(): Promise<void> {
      let R = await this.cookieService.get("xVal", true);
      if (R) {

        this.idnumber = R;
      
        

      }
  }

  passwordStrength = 0; // 0 to 8 (blocks)

onPasswordInput(password: string) {
  this.passwordStrength = 0;

  if (!password) return; // agar password empty ho, sab gray

  const lengthCriteria = password.length >= 8;
  const uppercaseCriteria = /[A-Z]/.test(password);
  const lowercaseCriteria = /[a-z]/.test(password);
  const numberCriteria = /\d/.test(password);
  const specialCharCriteria = /[\W_]/.test(password);

  const criteriaMet = [lengthCriteria, uppercaseCriteria, lowercaseCriteria, numberCriteria, specialCharCriteria]
    .filter(c => c).length;

  // Weak, Medium, Strong logic
  if (criteriaMet <= 2) {
    this.passwordStrength = 2; // weak -> first 2 blocks red
  } else if (criteriaMet === 3 || criteriaMet === 4) {
    this.passwordStrength = 5; // medium -> first 5 blocks yellow/orange
  } else if (criteriaMet === 5) {
    this.passwordStrength = 8; // strong -> all 8 blocks green
  }
}

  back() {
    this.location.back();
  }
  passwordMatchValidator(group: FormGroup) {
  const password = group.get('passwordCreateform')?.value;
  const confirmPassword = group.get('confirmPassword')?.value;

  return password === confirmPassword ? null : { passwordMismatch: true };
}

get passwordStrengthLabel(): string {
  if (this.passwordStrength > 0 && this.passwordStrength <= 2) {
    return 'WEAK';
  } else if (this.passwordStrength > 2 && this.passwordStrength < 8) {
    return 'MEDIUM';
  } else if (this.passwordStrength === 8) {
    return 'STRONG';
  } else {
    return ''; // default jab kuch enter na ho
  }
}

  showModal(num) {
    this.modalObservable.next(num);
  }
    getMessage(key, control) {

    let error = "";
    this.translate.get([key]).subscribe((data) => {
      if (control == "officeno") {
        if (key == "MobileMin") {
          error = data[key];
          error = error.replace("{minLength}", this.mobileminlength.toString());
        } else if (key == "MobileMax") {
          error = data[key];
          error = error.replace("{maxLength}", this.mobilemaxlength.toString());
        } else {
          error = data[key];
        }
      } else {
        error = data[key];
      }
    });
    return error;
  }

  createPassword(){

    this.commonService.presentLoading();
    let body = {
       IdNumber:this.idnumber,
       Password:this.createpass1,
       ConfirmPassword:this.confirmPass
   
    }

    this.pinservice.updatePasswordNew(body).then((res: any) => {
      if (res?.response?.code == 1) {
       this.commonService.hideLoading();
  
        this._router.navigateByUrl("/VerifyEmailOtp");
      }
      else {
        this.commonService.hideLoading();
        this.commonService.ParseErrorAlert('', 'OK', this._router, res);
      }
    })
  }

    isValid(): boolean {
  return this.createpassForm.invalid;
}
  
}
